import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import HistoryClosingReasonsAPI from '../../api/historyClosingReasons';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getHistoryClosingReasons(_state) {
    return _state.records;
  }
};

export const actions = {
  get: async ({ commit }, data) => {
    commit(types.SET_HISTORY_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isFetching: true });

    try {
      const response = await HistoryClosingReasonsAPI.get(data);
      commit(types.SET_HISTORY_CLOSING_REASONS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_HISTORY_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_HISTORY_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isCreating: true });

    try {
      const response = await HistoryClosingReasonsAPI.create(data);

      commit(types.ADD_HISTORY_CLOSING_REASONS, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_HISTORY_CLOSING_REASONS_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },
};

export const mutations = {
  [types.SET_HISTORY_CLOSING_REASONS_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_HISTORY_CLOSING_REASONS]: MutationHelpers.create,
  [types.SET_HISTORY_CLOSING_REASONS]: MutationHelpers.set,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
